export enum CommissionStatuses {
    DEADLINE_PASSED = '46af0ec0-3f85-4bd5-81b1-b0c26f42e6ab',
    OPEN = 'a5f7144f-0f28-4c4a-b895-825af51775c8',
    RETURNED = 'd16e0b68-2878-4604-8c2e-7d4561ca001b',
    SETTLED = 'a15f6d48-201a-4b44-ac98-ab6495f9eacf',
}
